/* eslint-disable no-inner-declarations, @typescript-eslint/no-namespace */
export namespace Utils {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	export const deepMerge = (...sources: any) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		let returnValue: any = {};

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		sources.forEach((source: any) => {
			if (Array.isArray(source)) {
				if (!Array.isArray(returnValue)) {
					returnValue = [];
				}

				returnValue = [...returnValue, ...source];
			} else if (isObject(source)) {
				Object.keys(source).forEach((key) => {
					let value = source[key];

					if (isObject(value) && Reflect.has(returnValue, key)) {
						value = deepMerge(returnValue[key], value);
					}

					returnValue = { ...returnValue, [key]: value };
				});
			}
		});

		return returnValue;
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const isObject = (value: any) => value !== null && typeof value === 'object';

	export const getCamelCased = (string: string) =>
		string.replace(/-([a-z])/g, (matches) => matches[1].toUpperCase());
}
